export default __webpack_public_path__ + "static/media/metlife-glyph.be81c921.png";